<div class="delivery-address-options">
  <button class="delivery-address-options-item btn-icon text-b4-l-500 color-black" (click)="onEdit()?.($event)">
    редактировать
  </button>
  <button class="delivery-address-options-item btn-icon text-b4-l-500 color-red" (click)="onDelete()?.()">
    удалить
  </button>
</div>
